var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lottie-player',{attrs:{"src":"https://assets8.lottiefiles.com/packages/lf20_bw7e3wn6.json","options":{
            autoplay: true,
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }